import api from './api'

export interface TelegramConnectData {
  api_id: number
  api_hash: string
  phone_number: string
}

export interface TelegramVerifyData {
  code: string
  password?: string
}

export interface TelegramStatus {
  connected: boolean
  username?: string | null
  telegram_user_id?: number | null
  phone_number?: string | null
  session_created_at?: string | null
}

export interface SendCodeResponse {
  message: string
  status: string
  phone_code_hash?: string
}

export interface VerifyCodeResponse {
  message: string
  status: string
  username?: string
  telegram_user_id?: number
}

export const telegramService = {
  async sendCode(data: TelegramConnectData): Promise<SendCodeResponse> {
    const response = await api.post<SendCodeResponse>('/telegram/send-code', data)
    return response.data
  },

  async verifyCode(data: TelegramVerifyData): Promise<VerifyCodeResponse> {
    const response = await api.post<VerifyCodeResponse>('/telegram/verify-code', data)
    return response.data
  },

  async getStatus(): Promise<TelegramStatus> {
    const response = await api.get<TelegramStatus>('/telegram/status')
    return response.data
  },

  async disconnect(): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>('/telegram/disconnect')
    return response.data
  },
}
